import { PAGES_CREATE_PAGE_NUDGE_ID } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { TAILORED_ONBOARDING_PAGES } from '@atlassian/jira-onboarding-quickstart-core/src/common/constants.tsx';
import { useMarkOpenTaskFromEligibleTasksAsCompleteAndExpand } from '@atlassian/jira-onboarding-quickstart-core/src/controllers/mark-open-task-from-eligible-tasks-as-complete-and-expand/index.tsx';
import messages from '../../common/messages.tsx';
import { useNudgeTour, useNudgeTourSteps } from '../nudge-tour/index.tsx';

export const PAGE_VIEW_ONBOARDING_TOUR_ID = 'pageViewOnboardingTour';

export const usePageNudgeTour = (nudgeId: string) =>
	useNudgeTour(nudgeId, {
		tourId: PAGE_VIEW_ONBOARDING_TOUR_ID,
		steps: useNudgeTourSteps(nudgeId, [PAGES_CREATE_PAGE_NUDGE_ID]),
		hideStepCountForSingleNudge: true,
		doneMessage: messages.nudgeCtaGotIt,
		onTourComplete: useMarkOpenTaskFromEligibleTasksAsCompleteAndExpand([
			TAILORED_ONBOARDING_PAGES,
		]),
	});
